import { render, staticRenderFns } from "./view404.vue?vue&type=template&id=225dce18&"
import script from "./view404.vue?vue&type=script&lang=js&"
export * from "./view404.vue?vue&type=script&lang=js&"
import style0 from "./view404.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports